import type { Store } from 'vuex';
import type { ApiServiceInterface } from '@travelata-libs/utils';
import { container } from './Container';
import { API_SERVICE_TOKEN, APP_CONFIG_TOKEN, STORE_TOKEN, TRACKER_TOKEN } from './tokens';
import type { AppConfig, DestinationTracker } from './types';

export interface InitLibraryOptions {
  store: Store<unknown>;
  config: AppConfig;
  apiService?: ApiServiceInterface;
  tracker?: DestinationTracker;
}

export function initLibrary(options: InitLibraryOptions): void {
  container.register(STORE_TOKEN, options.store);
  container.register(APP_CONFIG_TOKEN, options.config);
  if (options.apiService) {
    container.register(API_SERVICE_TOKEN, options.apiService);
  }
  if (options.tracker) {
    container.register(TRACKER_TOKEN, options.tracker);
  }
}
